export const NAVIGATION_DEPTH = 3
